import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Copy = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Copy" {...props}>
    <path d="M14 15H6V13H14V15Z" fill="#000" /><path d="M14 11H6V9H14V11Z" fill="#000" /><path fillRule="evenodd" clipRule="evenodd" d="M11.5967 1C12.732 1 13.8341 1.38645 14.7207 2.0957L17.123 4.01855C17.7988 4.55916 18.3139 5.25777 18.6318 6.04004C21.0949 6.35066 23 8.45262 23 11V18C23 20.7614 20.7614 23 18 23H9.75C7.34968 23 5.36599 21.2195 5.0459 18.9072C2.741 18.4617 1 16.435 1 14V6C1 3.23858 3.23858 1 6 1H11.5967ZM19 14C19 16.7614 16.7614 19 14 19H7.10645C7.43316 20.1539 8.4915 21 9.75 21H18C19.6569 21 21 19.6569 21 18V11C21 9.69415 20.1647 8.58594 19 8.17383V14ZM6 3C4.34315 3 3 4.34315 3 6V14C3 15.6569 4.34315 17 6 17H14C15.6569 17 17 15.6569 17 14V8H14C12.3431 8 11 6.65685 11 5V3H6ZM13 5C13 5.55228 13.4477 6 14 6H16.3018C16.1744 5.84757 16.0319 5.70637 15.874 5.58008L13.4707 3.65723C13.3231 3.53919 13.1651 3.43702 13 3.34961V5Z" fill="#000" />
  </StyledIcon>
));

Copy.displayName = 'Copy';

export { Copy };
